import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { useApp } from "../../Context";
import { formatNumber } from "../../Util/priceFormatter";
import { CustomCategoryDropdown } from "../CustomCategoryDropdown";
import { PriceSliderDropdown } from "../PriceSliderDropdown";
import { DistanceSliderDropdown } from "../DistanceSliderDropdown";

//import assets
import Magnifying from "../../Assets/Magnifying";
import Filter from "../../Assets/Filter";
import { SearchIntentModal } from "../Modals";

export const SearchBar = ({ handleShowFilter, showType }) => {
  const navigate = useNavigate();
  const { filters, setFilters, setSearchMode } = useApp();
  const [result, setResult] = useState([]);
  const [query, setQuery] = useState("");
  const [showIntentModal, setShowIntentModal] = useState(false);
  const [showPriceSlider, setShowPriceSlider] = useState(false);
  const [showDistanceSlider, setShowDistanceSlider] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const resultsRef = useRef(null);
  const priceInputRef = useRef(null);
  const distanceInputRef = useRef(null);

  const handleSuggestCity = (e) => {
    let text = e.target.value;
    setQuery(text);
    if (text) {
      const config = {
        method: "get",
        url: `https://api.geoapify.com/v1/geocode/autocomplete?text=${text}&lang=de&apiKey=3ed82eac110f4fabbad64b85f8cbe6c2`,
        headers: {},
      };
  
      axios(config)
        .then(function (response) {
          setResult(response.data.features);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      setResult([]);
    }
  };

  const handleSelectCity = (city) => {
    setQuery(city);
    setResult([]);
    setFilters((prev) => ({
      ...prev,
      city: city,
    }));
  };

  // Funktion zum Formatieren des Preis-Bereichs
  const getFormattedPriceRange = () => {
    const minPrice = filters.minPrice;
    const maxPrice = filters.maxPrice;
    
    if (!minPrice && !maxPrice) return 'Preis';
    
    if (minPrice && maxPrice) {
      return `${formatNumber(minPrice)} - ${formatNumber(maxPrice)}`;
    }
    
    if (minPrice) {
      return `ab ${formatNumber(minPrice)}`;
    }
    
    if (maxPrice) {
      return `bis ${formatNumber(maxPrice)}`;
    }
    
    return 'Preis';
  };

  const handleFilter = () => {
    setShowIntentModal(true);
  };

  const handleIntentModalClose = () => {
    setShowIntentModal(false);
  };

  const handleBrowse = () => {
    setSearchMode('browse');
    setShowIntentModal(false);
    navigate("/filter");
  };

  const handleCreateRequest = () => {
    // Debug: Zeige Filter-Werte
    console.log('SearchBar - Filter values:', filters);
    console.log('SearchBar - Name:', filters.name, 'Type:', typeof filters.name);
    console.log('SearchBar - Mail:', filters.mail, 'Type:', typeof filters.mail);
    
    // Prüfe ob Name und E-Mail ausgefüllt sind (auch auf Whitespace prüfen)
    const nameEmpty = !filters.name || filters.name.trim() === '';
    const mailEmpty = !filters.mail || filters.mail.trim() === '';
    
    if (nameEmpty || mailEmpty) {
      // Zeige inline Fehlermeldung
      const missingFields = [];
      if (nameEmpty) missingFields.push("Vor- und Nachname");
      if (mailEmpty) missingFields.push("E-Mail");
      
      setValidationError({
        missingFields: missingFields
      });
      return;
    }
    
    // Validierung erfolgreich - lösche Fehlermeldung und setze SearchMode
    setValidationError(null);
    setSearchMode('create-request');
    setShowIntentModal(false);
    
    // Navigiere zur Filter-Seite - die Daten werden automatisch über useGetFilterAdvertiseQuery gesendet
    navigate("/filter");
  };

  return (
    <div className="flex w-full bg-background h-16 rounded-full items-center px-2 py-2 md:gap-5 gap-2 ">
      <div className="relative ml-2">
        <div className="flex gap-x-2 items-center">
          <Magnifying />
          <input
            name="city"
            value={query}
            onChange={handleSuggestCity}
            placeholder="Stadt suchen"
            className="text-primary font-light font-helvetica placeholder:text-primary bg-background focus:outline-none"
          />
        </div>
        {result.length > 0 && (
          <div
            ref={resultsRef}
            className="absolute top-12 left-0 right-0 flex flex-col gap-2 bg-background shadow-md rounded-sm p-2 z-10 opacity-90"
          >
            {result.map((item, idx) => (
              <a
                key={idx}
                className="text-sm font-helvetica cursor-pointer hover:bg-blue-gray-300 hover:text-white p-1 text-primary"
                onClick={() => handleSelectCity(item.properties.city)}
              >
                {item.properties.city}
              </a>
            ))}
          </div>
        )}
      </div>

      {/* {showType && (
        <div className="flex gap-2 absolute top-[-40px] ">
          <Radio
            name="Werbetyp"
            label={
              <p className="font-helvetica font-semibold text-white">Mieten</p>
            }
            value="Mieten" // Set the value to the desired option
            checked={filters.advertise_type === "Mieten"} // Add a checked prop to indicate the current state
            onChange={() =>
              setFilters({ ...filters, advertise_type: "Mieten" })
            }
            icon={<div className="w-3 h-3 rounded-full bg-primary" />}
            className="border-2 border-primary bg-white p-0 m-0 transition-all hover:before:opacity-0 focus:border-primary"
            ripple={false}
          />

          <Radio
            name="Werbetyp"
            value="Kaufen" // Set the value to the desired option
            checked={filters.advertise_type === "Kaufen"} // Add a checked prop to indicate the current state
            onChange={() =>
              setFilters({ ...filters, advertise_type: "Kaufen" })
            }
            label={
              <p className="font-helvetica font-semibold text-white">Kaufen</p>
            }
            icon={<div className="w-3 h-3 rounded-full bg-primary" />}
            className="border-2 border-primary bg-white p-0 transition-all hover:before:opacity-0 focus:border-primary"
            ripple={false}
          />
        </div>
      )} */}

 

      <input
        ref={distanceInputRef}
        name="minArea"
        value={filters.minArea ? `+${filters.minArea} km` : '+20 km'}
        readOnly
        onClick={() => setShowDistanceSlider(true)}
        className="text-primary w-20 font-light font-helvetica md:block sm:hidden bg-inherit focus:outline-none cursor-pointer"
      />
      <div className="w-[1px]  h-full bg-gray-500 md:block sm:hidden" />
      <div className="md:flex gap-x-5 items-center sm:hidden">
        <p className="text-primary text-xl cursor-default font-extralight">€</p>
        <input
          ref={priceInputRef}
          name="minPrice"
          value={getFormattedPriceRange()}
          readOnly
          onClick={() => setShowPriceSlider(true)}
          className="text-primary font-light w-32 font-helvetica bg-inherit focus:outline-none cursor-pointer"
          placeholder="Preis"
        />
      </div>
      <div className="w-[1px] h-full bg-gray-500 md:block sm:hidden" />
      <div className="md:flex gap-x-3 items-center sm:hidden">
        <CustomCategoryDropdown filters={filters} setFilters={setFilters} />
      </div>
      <div className="w-[1px] h-full bg-gray-500" />
      <button
        className="flex gap-2 items-center text-primary font-light font-helvetica border border-1 border-primary px-8 h-full rounded-full"
        onClick={handleShowFilter}
      >
        <Filter />
        Filter
      </button>
      <button
        className="md:block sm:hidden font-light font-helvetica text-white bg-primary px-8 h-full rounded-full"
        onClick={handleFilter}
      >
        Suchen
      </button>
      
      <SearchIntentModal 
        open={showIntentModal} 
        handler={handleIntentModalClose}
        onBrowse={handleBrowse}
        onCreateRequest={handleCreateRequest}
        validationError={validationError}
      />
      
      <PriceSliderDropdown 
        filters={filters}
        setFilters={setFilters}
        isOpen={showPriceSlider}
        onClose={() => setShowPriceSlider(false)}
        inputRef={priceInputRef}
      />
      
      <DistanceSliderDropdown 
        filters={filters}
        setFilters={setFilters}
        isOpen={showDistanceSlider}
        onClose={() => setShowDistanceSlider(false)}
        inputRef={distanceInputRef}
      />
    </div>
  );
};
